import { ARTWORK_ALIASES, ARTWORK_SLOTS } from './artworkSlots';

/**
 * The logo props of the 3D preview in one shape: `{ [slotName]: { url, inverted } }`
 * (2026-11-04). The preview keeps taking `frontImage` / `backImage` (+ `…Inverted`) —
 * the CreateSchool form and the design-system page pass those — and a `logos` map for
 * every artwork slot; an explicit `logos` entry wins over its alias.
 *
 * @param {{frontImage?: string|null, backImage?: string|null, frontImageInverted?: boolean, backImageInverted?: boolean, logos?: object|null}} props
 * @returns {{[slot: string]: {url: string, inverted: boolean}}}
 */
export function mergeLogoProps(props = {}) {
  const out = {};
  for (const [slot, alias] of Object.entries(ARTWORK_ALIASES)) {
    const url = props[alias.image];
    if (typeof url === 'string' && url) out[slot] = { url, inverted: !!props[alias.inverted] };
  }
  for (const [slot, entry] of Object.entries(props.logos || {})) {
    if (!ARTWORK_SLOTS.includes(slot)) continue;
    if (entry && typeof entry.url === 'string' && entry.url) out[slot] = { url: entry.url, inverted: !!entry.inverted };
    else delete out[slot];
  }
  return out;
}

/**
 * The alias props derived from a `logos` map — what a DK consumer reads today
 * (`frontImage`, `frontImageInverted`, `backImage`, `backImageInverted`); keys are
 * present only when the slot has a URL (the inverted flag only when true), so a map
 * with just the two classic slots yields exactly the props the resolver used to emit.
 */
export function aliasesOfLogos(logos = {}) {
  const out = {};
  for (const [slot, alias] of Object.entries(ARTWORK_ALIASES)) {
    const entry = logos?.[slot];
    if (!entry?.url) continue;
    out[alias.image] = entry.url;
    if (entry.inverted) out[alias.inverted] = true;
  }
  return out;
}
